// extracted by mini-css-extract-plugin
export default {"previewLink":"activity_preview_link-module___previewLink___fc0f56e0"};